import {observer} from 'mobx-react';
import React from 'react';
import ModalSimple from '../../../../global/modal-simple';
import CartMobile from './cart-mobile';
import {computed} from 'mobx';
import store from '../../../s';
import {getCartItemTotal} from '../cart-quantity/cart-quantity';

@observer
class ModalCartMobile extends React.Component {
    @computed get cartItemTotal() {
        return getCartItemTotal(store.checkout.cart.items);
    }

    render() {
        return (
            <ModalSimple
                id="modal-cart-mobile"
                title={`Your Cart (${this.cartItemTotal})`}
                open={true}
                abTestClass="cart-mobile-ab-test"
                close={() => window.history.back()}
            >
                <CartMobile />
            </ModalSimple>
        );
    }
}

export default ModalCartMobile;
